export interface VendorPreset {
  id: string; name: string; dpi: number;
  minLinePx: number; minGapPx: number; minSpeckArea: number;
  maxWidthIn: number; maxHeightIn: number; spacingIn: number;
  notes?: string;
}

export const PRESETS: VendorPreset[] = [
  { id: 'generic', name: 'Generic DTF (research consensus)', dpi: 300, minLinePx: 6, minGapPx: 8, minSpeckArea: 36, maxWidthIn: 22, maxHeightIn: 240, spacingIn: 0.25 },
  { id: 'ninja', name: 'Ninja Transfers', dpi: 300, minLinePx: 6, minGapPx: 8, minSpeckArea: 36, maxWidthIn: 22, maxHeightIn: 240, spacingIn: 1, notes: 'Elements under 0.02 in may not transfer; 1 in spacing on gang sheets.' },
  { id: 'stahls', name: 'Stahls / Transfer Express UltraColor', dpi: 300, minLinePx: 6, minGapPx: 8, minSpeckArea: 36, maxWidthIn: 22, maxHeightIn: 22, spacingIn: 0.25, notes: 'Min line 0.018 in; 150 dpi floor; max 22x22 in.' },
  { id: 'supacolor', name: 'Supacolor', dpi: 300, minLinePx: 3, minGapPx: 8, minSpeckArea: 36, maxWidthIn: 22, maxHeightIn: 240, spacingIn: 0.25, notes: 'Min line 0.2 mm / 0.6 pt; keep glows inside the edge.' },
  { id: 'transfer-superstars', name: 'Transfer Superstars', dpi: 300, minLinePx: 6, minGapPx: 8, minSpeckArea: 36, maxWidthIn: 22.4, maxHeightIn: 240, spacingIn: 0.25, notes: 'Min line 6 px; sheet 22.4 in.' },
];

export function getPreset(id: string): VendorPreset {
  const p = PRESETS.find((x) => x.id === id);
  if (!p) throw new Error(`unknown preset ${id}`);
  return p;
}
